import { instance } from "api/apiBase";
import { Applicant } from "types/application";
import {
  ApplicationDecision,
  ApplicationMetricsResponse,
  ApplicationMetricTemplateEntry,
  ApplicationSummary
} from "./types";

const api = {
  getApplicationSummary: async (id: string): Promise<ApplicationSummary> => {
    return (
      await instance.get<ApplicationSummary>(
        `/portal/v1/applications/${id}/summary`
      )
    ).data;
  },
  getApplicationDecision: async (id: string): Promise<ApplicationDecision> => {
    return (
      await instance.get<ApplicationDecision>(
        `/portal/v1/applications/${id}/decision`
      )
    ).data;
  },
  getApplicationMetrics: async (
    id: string
  ): Promise<ApplicationMetricsResponse> => {
    return (
      await instance.get<ApplicationMetricsResponse>(
        `/portal/v1/applications/${id}/metrics`
      )
    ).data;
  },
  updateApplicationMetricsTemplate: async (
    template: ApplicationMetricTemplateEntry[]
  ): Promise<{ template: ApplicationMetricTemplateEntry[] }> => {
    return (
      await instance.patch(`/portal/v1/users/application_metrics_template`, {
        template
      })
    ).data;
  },
  resetApplicationMetricsTemplate: async (): Promise<void> => {
    await instance.delete(`/portal/v1/users/application_metrics_template`);
  },
  getApplicantDetail: async (
    applicationId: string,
    applicantId: string
  ): Promise<Applicant> => {
    return (
      await instance.get<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}`
      )
    ).data;
  },
  createDocumentRequest: async ({
    applicationId,
    applicantId,
    note
  }: {
    applicationId: string;
    applicantId: string;
    note: string;
  }): Promise<Applicant> => {
    return (
      await instance.post<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/document_requests`,
        { note }
      )
    ).data;
  },
  markDocumentRequestsSeen: async ({
    applicantId,
    applicationId
  }: {
    applicationId: string;
    applicantId: string;
  }): Promise<Applicant> => {
    return (
      await instance.patch<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/document_requests/mark_seen`
      )
    ).data;
  }
};

export default api;
